import React from "react";
import { useHistory } from "react-router-dom";

import Card from "@material-ui/core/Card";
// import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";

import { SimpleShowLayout, TextField } from "jazasoft";
import CardHeader from "../components/CardHeader";
import LinkField from "../components/LinkField";

const fieldOptions = {
  xs: 12,
  sm: 3
};

const OrderDetails = ({ record, basePath, resource, i18nKey, className, id, dividerStyle = {} }) => {
  const history = useHistory();

  return (
    <Card id={id} className={className}>
      <CardHeader title="Order Details" />
      <Divider style={dividerStyle} />
      <CardContent>
        <SimpleShowLayout record={record} basePath={basePath} resource={resource} i18nKey={i18nKey} footer={false}>
          <LinkField source="poRef" {...fieldOptions} onClick={() => history.push(`/orders/${record?.id}/view`)} />
          <TextField source="customerPoRef" {...fieldOptions} />
          <TextField label="Customer" source="customer.name" {...fieldOptions} />
          <TextField label="Season" source="season.name" {...fieldOptions} />
          <TextField source="desc" {...fieldOptions} />
        </SimpleShowLayout>
      </CardContent>
    </Card>
  );
};

export default OrderDetails;
